<div class="filter-for-list">


  <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
    <input matInput (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
  </mat-form-field>
  <div class="statusSelector" placement="top" [ngbTooltip]="'ALARM_VALIDATOR_TOOLTIP' | translate">
    {{'ALARM_VALIDATOR_STATUS'|translate}} :
    <fa-icon (click)="reLoadList(STATUS.REJECTED.VALUE)" class="statusAbo"
             [ngClass]="STATUS.REJECTED.COLOR"
             [icon]="STATUS.REJECTED.ICON"></fa-icon>
    <fa-icon (click)="reLoadList(STATUS.TO_VALID.VALUE)" class="statusAbo"
             [ngClass]="STATUS.TO_VALID.COLOR"
             [icon]="STATUS.TO_VALID.ICON"></fa-icon>
    <fa-icon (click)="reLoadList(STATUS.VALID.VALUE)" class="statusAbo"
             [ngClass]="STATUS.VALID.COLOR"
             [icon]="STATUS.VALID.ICON"></fa-icon>
  </div>
  <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner===true"></app-progressbar>
<table mat-table [dataSource]="validableAlarmsList" matSort class="table-striped" style="width:100%" matSortActive="id"
       matSortDirection="asc">

  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
    <td mat-cell *matCellDef="let validableAlarm"> {{validableAlarm.id}}</td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'STATE'|translate}}</th>
    <td mat-cell *matCellDef="let validableAlarm">
      <fa-icon *ngIf="validableAlarm.status.toString() === STATUS.REJECTED.VALUE" class="statusAbo"
               [ngClass]="STATUS.REJECTED.COLOR"
               [icon]="STATUS.REJECTED.ICON"></fa-icon>
      <fa-icon *ngIf="validableAlarm.status.toString() === STATUS.TO_VALID.VALUE" class="statusAbo"
               [ngClass]="STATUS.TO_VALID.COLOR"
               [icon]="STATUS.TO_VALID.ICON"></fa-icon>
      <fa-icon *ngIf="validableAlarm.status.toString() === STATUS.VALID.VALUE" class="statusAbo"
               [ngClass]="STATUS.VALID.COLOR"
               [icon]="STATUS.VALID.ICON"></fa-icon>
    </td>
  </ng-container>


  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE'|translate}}</th>
    <td mat-cell *matCellDef="let validableAlarm">
      <mat-chip-list>
        <mat-chip style="background: #e91e63;color:#fff">
          {{validableAlarm.type | translate}}
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME'|translate}}</th>
    <td mat-cell *matCellDef="let validableAlarm">
      <mat-chip-list>
        <mat-chip
          class="link"
          placement="left"
          [ngbTooltip]="'READ_ICON_TOOLTIP' | translate"
          (click)="openModal('read',validableAlarm.id)">
          {{validableAlarm.name}}
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="parentAlarmName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PARENT'|translate}}</th>
    <td mat-cell *matCellDef="let validableAlarm">
      <mat-chip-list *ngIf="validableAlarm.parentAlarmId">
        <mat-chip
          placement="left"
          [ngbTooltip]="'READ_ICON_TOOLTIP' | translate"
          (click)="openModal('read',validableAlarm.parentAlarmId)"
          class="location">{{validableAlarm.parentAlarmName}}</mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="projectName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PROJECT'|translate}}</th>
    <td mat-cell *matCellDef="let validableAlarm">

      <mat-chip-list>
        <mat-chip placement="right"
                  [ngbTooltip]="'READ_ICON_TOOLTIP' | translate"
                  class="selected link" [routerLink]="'/projects-view/'+validableAlarm.projectId">
          {{validableAlarm.projectName}}
        </mat-chip>
      </mat-chip-list>

    </td>
  </ng-container>


  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef width="130px">{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let validableAlarm">
      <div class="actions" *ngIf="!showSpinner">

        <fa-icon [ngbTooltip]="'INVALIDATE_ALARM_TOOLTIP' | translate"
                 (click)="inValidateAlarm(validableAlarm.id)" class="statusAbo"
                 [ngClass]="STATUS.REJECTED.COLOR"
                 [icon]="STATUS.REJECTED.ICON"></fa-icon>

        <fa-icon [ngbTooltip]="'VALIDATE_ALARM_TOOLTIP' | translate"
                 (click)="validateAlarm(validableAlarm.id)" class="statusAbo"
                 [ngClass]="STATUS.VALID.COLOR"
                 [icon]="STATUS.VALID.ICON"></fa-icon>

      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>
<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="pageSize"></mat-paginator>



